(() => {
  console.log('salenti-token.js');
  const token = new URLSearchParams(window.location.search).get('tk');
  if (!token) return;

  const cartUpdateUrl =
    typeof Theme !== 'undefined' && Theme.routes?.cart_update_url
      ? Theme.routes.cart_update_url + '.js'
      : '/cart/update.js';

  fetch(cartUpdateUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        __salenti_token: token,
      },
    }),
  }).catch(() => {
    // Silently ignore network errors; token capture should not block the page.
  });
})();
